'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSortableHoc = require('react-sortable-hoc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortableItem = (0, _reactSortableHoc.sortableElement)(function (_ref) {
  var value = _ref.value,
      dragIcon = _ref.dragIcon;

  return _react2.default.cloneElement(value, { dragIcon: dragIcon });
});

var SortableContainer = (0, _reactSortableHoc.sortableContainer)(function (_ref2) {
  var children = _ref2.children,
      className = _ref2.className;

  return _react2.default.createElement(
    'div',
    { className: className },
    children
  );
});

var SortableList = function (_Component) {
  _inherits(SortableList, _Component);

  function SortableList(props) {
    _classCallCheck(this, SortableList);

    var _this = _possibleConstructorReturn(this, (SortableList.__proto__ || Object.getPrototypeOf(SortableList)).call(this, props));

    _this.onSortStart = function (_ref3) {
      var index = _ref3.index;

      _this.props.onStart && _this.props.onStart(index);
    };

    _this.onSortMove = function (event) {
      _this.props.onMove && _this.props.onMove(event);
    };

    _this.onSortEnd = function (_ref4, e) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;

      _this.setState(function (_ref5) {
        var items = _ref5.items;
        return {
          items: (0, _reactSortableHoc.arrayMove)(items, oldIndex, newIndex)
        };
      }, function () {
        _this.props.onEnd && _this.props.onEnd(oldIndex, newIndex, e);
      });
    };

    _this.state = {
      items: _this.props.children
    };
    return _this;
  }

  _createClass(SortableList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mynode = _reactDom2.default.findDOMNode(this.node);
      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.state.items;
      var _props = this.props,
          dragIcon = _props.dragIcon,
          className = _props.className;

      return _react2.default.createElement(
        SortableContainer,
        {
          useDragHandle: dragIcon != null,
          ref: function ref(n) {
            return _this2.node = n;
          },
          onSortStart: this.onSortStart,
          onSortMove: this.onSortMove,
          onSortEnd: this.onSortEnd,
          helperContainer: this.mynode,
          helperClass: 'help',
          className: className
        },
        items.map(function (value, index) {
          return _react2.default.createElement(SortableItem, {
            key: 'item-' + index,
            index: index,
            value: value,
            dragIcon: dragIcon
          });
        })
      );
    }
  }]);

  return SortableList;
}(_react.Component);

SortableList.displayName = 'SortableList';

exports.default = SortableList;